import styled from 'styled-components';
import { minWidth } from 'helpers/buildMediaQueries';
import {
  Trustmark,
  fontVariables,
  colorsVariables,
  flexItemsCentered,
  flexColumn,
  gutterVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';

export const CertificateArea = styled.div<{ $isValid: boolean }>`
  font-size: ${fontVariables.SIZE_TEXT_S};
  grid-template-areas: 'trustmarkImg trustmark-buyerprotection';
  align-items: center;
  ${minWidth(
    'xl',
    `
    display: grid;
    grid-template-columns: min-content max-content;
    grid-area: 1 / 2 / span 2 / 2; 
    grid-template-columns: min-content auto; 
    grid-template-rows: auto;
    `
  )}

  ${(props) => !props.$isValid && minWidth('xl', 'align-self: center;')}
`;

export const TrustmarkImg = styled(Trustmark)`
  width: 46px;
  height: 46px;
  grid-area: trustmarkImg;
  margin-right: ${gutterVariables.GUTTER_HALF};
`;

export const TrustmarkBuyerprotection = styled.div`
  grid-area: trustmark-buyerprotection;
  display: flex;
`;

export const TrustmarkText = styled.span<{ $isValid: boolean }>`
  font-size: ${fontVariables.SIZE_TEXT_M};
  line-height: ${fontVariables.LINE_HEIGHT_S};
  font-weight: ${fontVariables.FONT_WEIGHT_BOLD};
  display: inline-block;
  color: ${colorsVariables.BLACK};
  margin-right: 3px;
  ${minWidth('xl', 'display: block; margin-right: 10px;')}
`;

export const CertificationInformationWrapper = styled.div`
  ${flexColumn};
  justify-content: center;
`;

export const CertificationTextAndValidity = styled.div`
  ${flexItemsCentered};
`;

export const BuyerProtectionText = styled.span`
  white-space: nowrap;
  display: inline-block;
  margin-bottom: 1px;
  margin-top: ${gutterVariables.GUTTER_ONE_QUARTER};
  color: ${colorsVariables.GRAY_700};
  line-height: ${fontVariables.LINE_HEIGHT};
  font-size: ${fontVariables.SIZE_TEXT_S};
  ${minWidth('xl', 'grid-area: 2 / 1 / 2 / span 2; margin-bottom: 0;')}
`;

export const CertificationState = styled.span<{ $isValid: boolean }>`
  border-radius: 3px;
  font-size: ${fontVariables.SIZE_TEXT_XS};
  padding: ${gutterVariables.GUTTER_ONE_QUARTER} 6px;
  font-weight: bold;
  justify-self: end;
  grid-area: 1 / 3 / 1 / 3;
  line-height: ${fontVariables.LINE_HEIGHT_XS};
  ${(props: { $isValid: boolean }) =>
    props.$isValid
      ? `background-color: #E3FFE8; color: ${colorsVariables.GREEN_500}`
      : `background-color: ${colorsVariables.RED_100}; color: ${colorsVariables.RED_400}`};
  ${minWidth('xl', 'justify-self: start; grid-area: 1 / 2 / 1 / 3;')}
  white-space: nowrap;
`;
